import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { loadChatbotStartChat } from '../../common/thunks/chatbotStartChat.thunk';
import { ErrorScreen } from '../../error';
import { appRoutes } from '../../routes';
import { widgetSDK } from '../../sdk/widgetSDK';

export const ChatbotErrorScreen = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onRefresh = useCallback(() => {
    const reload = async () => {
      const context = await widgetSDK.getContext();
      dispatch(loadChatbotStartChat(context));
      navigate(appRoutes.chatbot());
    };

    reload();
  }, [dispatch, navigate]);

  return <ErrorScreen onRefresh={onRefresh} />;
};
